import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableItemAddedEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.referenceTableId}/item/${payload.itemId}`,
            type: ReferenceTableItemAddedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableItemAddedEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableItemAddedEvent';
ReferenceTableItemAddedEvent.type = 'com.treeplotter.api.reference-table.item-added.v1';
EventRegistry.register(ReferenceTableItemAddedEvent.type, ReferenceTableItemAddedEvent);
//# sourceMappingURL=reference-table-item-added.event.js.map